var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9596 11.9995C19.6796 11.9997 19.4089 12.0979 19.196 12.2763C18.9832 12.4547 18.8422 12.7017 18.7984 12.973L16.8691 24.9733C16.9591 24.4129 17.4515 23.9999 18.0303 23.9999H23.6837C29.3735 23.9999 34.2015 19.9292 35.0837 14.4129C35.1494 14.001 35.1866 13.5853 35.1951 13.1685C33.7491 12.425 32.0505 11.9995 30.1894 11.9995H19.9596Z",
    fill: "#001C64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1936 13.1675C35.1851 13.5842 35.1479 14 35.0823 14.4118C34.2001 19.9281 29.3716 23.9988 23.6822 23.9988H18.0288C17.4505 23.9988 16.9576 24.4114 16.8677 24.9723L15.0937 35.9996L13.9826 42.9175C13.9609 43.0512 13.969 43.1879 14.0064 43.3181C14.0438 43.4484 14.1096 43.5692 14.1992 43.6721C14.2888 43.775 14.4001 43.8576 14.5255 43.9143C14.6508 43.9709 14.7872 44.0002 14.9252 44.0001H21.0615C21.3415 43.9999 21.6122 43.9018 21.8251 43.7233C22.0379 43.5449 22.1789 43.2979 22.2226 43.0267L23.839 32.9728C23.8828 32.7014 24.0239 32.4543 24.2369 32.2758C24.4499 32.0974 24.7209 31.9994 25.001 31.9993H28.6139C34.3037 31.9993 39.1317 27.9287 40.0139 22.4123C40.6403 18.4972 38.6297 14.9344 35.1936 13.1675Z",
    fill: "#0070E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 4C12.41 4 11.9171 4.41255 11.8272 4.97256L7.01185 34.9182C6.92054 35.4867 7.36847 36.0008 7.95539 36.0008H15.0961L16.8692 24.9734L18.7985 12.9731C18.8423 12.7019 18.9832 12.4549 19.1961 12.2764C19.4089 12.098 19.6796 11.9999 19.9596 11.9996H30.1894C32.051 11.9996 33.7491 12.4256 35.1951 13.1687C35.2941 8.1464 31.0684 4 25.2587 4H12.9883Z",
    fill: "#003087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.fdd7dce44ef20dc3bb7e68af98f7ee89.svg";
export { ForwardRef as ReactComponent };